import React from 'react';
import Intro from './components/Intro';
import AboutCard from './components/AboutCard';
import Philosophy from './components/Philosophy';

const About = () => {
  return (
    <>
      <Intro />
      <AboutCard />
      <Philosophy />
    </>
  );
};

export default About;
